import React, { useEffect, useState } from 'react'
import { axiosGet } from '../util/api'
import { Layout } from '../components/Layout'

export const Undo = () => {
    const [loading, setLoading] = useState(true)
    const [exists, setExists] = useState(false)

    const load = () => {
        setLoading(true)
        axiosGet('undo')
            .then((res) => {
                setExists(res.data.exists)
                setLoading(false)
            })
            .catch((err) => {
                setLoading(false)
                console.error(err)
            })
    }

    useEffect(() => {
        load()
    }, [])

    return (
        <Layout primary="Undo">
            <div className="flex flex-col items-center mt-20">
                {!loading && exists && (
                    <>
                        <div>We found undo files for your account.</div>
                        <a href="/api/v1/undo/download">Download undo bulk files</a>
                    </>
                )}
                {!loading && !exists && <>We didn't find any undo files for your account.</>}
                {loading && <div>Loading...</div>}
            </div>
        </Layout>
    )
}
